<script>
import LoginComponent from "@/components/Auth/Login";
import SignupComponent from "@/components/Auth/Signup";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

const uuid = require("uuid");

export default {
  components: {
    LoginComponent,
    SignupComponent,
    Loader: () => import("@/components/Loader.vue"),
    SalesPaystackButton: () =>
      import("@/components/payments/salesPaystackButton.vue"),
  },

  props: ["id"],
  data() {
    return {
      item: {},
      deliveryMethod: "",
      totalPrice: 0,
    };
  },

  created() {
    console.log(this.$route.params.id);
    const id = this.$route.params.id;
    console.log(id);
    this.fetchItem(id);
  },

  computed: {},

  methods: {
    logDelivery() {
      if (this.deliveryMethod === "Pudo Locker-to-Locker - R60") {
        this.deliveryFee = 60;
      } else if (this.deliveryMethod === "Pudo Locker-to-Door - R80") {
        this.deliveryFee = 80;
      } else {
        this.deliveryFee = 0;
      }
      console.log(this.deliveryFee, this.item.price);
      this.totalPrice = this.deliveryFee + Number(this.item.price);
    },
    async fetchItem(id) {
      try {
        const db = getFirestore();
        const q = query(collection(db, "salesItems"), where("id", "==", id));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          this.item = doc.data();
          this.selectedImage = this.item.images[0];
          console.log("success", this.item);
        } else {
          console.log("Item not found!");
        }
      } catch (error) {
        console.error("Error fetching item:", error);
      }
    },
    paySuccess() {
      console.log("ORDER PAY SUCCESS");

      //update booking in datas status to awaiting-images
      this.booking.status = "awaiting-images";
      this.$store.commit("setLoading", true);

      this.$store
        .dispatch("updateBookingData", {
          id: this.booking.id,
          status: "awaiting-images",
        })
        .then(() => {
          // this.paySnackbar = true;
          this.$store.commit("setLoading", false);
          this.successDialog = true;
        });
    },
  },
};
</script>

<template>
  <v-container style="padding-top: 0px; max-width: 1096px">
    <v-dialog
      v-model="successDialog"
      max-width="450px"
      persistent
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title class="text-center black--text">
            <p class="my-3 ml-auto mr-auto">Woohoo!</p>
          </v-card-title>
          <v-divider></v-divider>
          <div class="grid">
            <v-img
              size="small"
              width="300px"
              height="300px"
              :src="require('@/assets/svgs/celebrate-1.svg')"
            ></v-img>
          </div>
          <v-card-text class="my-2">
            Your payment was successful and the lender has been notified. 🎉
            Feel free contact them to organise pickup or delivery.
          </v-card-text>

          <v-card-actions class="mt-n9">
            <v-col>
              <v-row class="my-3">
                <v-btn
                  block
                  class="btn white--text"
                  style="border-radius: 8px !important"
                  color="accent"
                  @click="successDialog = false"
                >
                  Continue
                </v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <template v-if="item">
      <v-row style="padding: 16px">
        <v-col cols="12" md="12">
          <v-col>
            <v-row> </v-row>
            <v-row class="center">
              <v-icon
                style="position: fixed; left: 24px"
                color="black"
                @click="$router.go(-1)"
                >fas fa-arrow-left</v-icon
              >
              <h2
                :class="[$vuetify.breakpoint.mdAndUp ? 'h6' : 'h6']"
                class="font-weight-bold accent--text text-center"
              >
                Confirm Order
              </h2>
            </v-row>
            <v-row class="grid">
              <v-img
                :src="item.images ? item.images[0] : ''"
                height="125px"
                width="125px"
                contain
              />
            </v-row>
            <v-row class="center mt-6">
              <h2
                :class="[$vuetify.breakpoint.mdAndUp ? 'h1' : 'h1']"
                class="font-weight-bold black--text text-center"
                style="font-size: 2rem"
              >
                R{{ item.price }}
              </h2>
            </v-row>
            <v-row class="center">
              <p style="font-size: 1.2rem" class="black--text text-center">
                {{ item.itemName }}
              </p>

              <p class="text-center caption">{{ item.description }}</p>
            </v-row>

            <v-row>
              <h2
                :class="[$vuetify.breakpoint.mdAndUp ? 'title' : 'title']"
                class="font-weight-bold accent--text text-center"
              >
                Delivery Method
              </h2>
            </v-row>
            <v-card
              class="pl-3 pr-3 mt-5"
              outlined
              style="border-radius: 13px; width: 100%"
            >
              <v-radio-group v-model="deliveryMethod" @change="logDelivery()">
                <v-radio
                  label="Pudo Locker-to-Locker - R60"
                  value="Pudo Locker-to-Locker - R60"
                ></v-radio>
                <v-text-field
                  v-if="deliveryMethod === 'Pudo Locker-to-Locker - R60'"
                  placeholder="Select locker location"
                ></v-text-field>
                <v-divider class="mb-2"></v-divider>
                <v-radio
                  label="Pudo Locker-to-Door - R80"
                  value="Pudo Locker-to-Door - R80"
                ></v-radio>
                <v-text-field
                  v-if="deliveryMethod === 'Pudo Locker-to-Door - R80'"
                  placeholder="Provide delivery address"
                ></v-text-field>
                <v-divider class="mb-2"></v-divider>
                <v-radio
                  label="Collect from Seller - Free"
                  value="Collect from Seller - Free"
                ></v-radio>
                <v-divider class="mb-2"></v-divider>
              </v-radio-group>

              <v-row class="grid">
                <sales-paystack-button
                  @paySuccess="paySuccess()"
                  :item="this.item"
                ></sales-paystack-button>
              </v-row>
            </v-card>
          </v-col>
          <!-- <div
            class="font-weight-bold h2 secondary--text"
            style="
              margin-left: 24px;
              margin-top: 8px;
              text-align: left;
              justify: left;
            "
          >
            <svg
              height="20px"
              width="20px"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="location-dot"
              class="svg-inline--fa fa-location-dot"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="#F8955B"
                  d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                ></path>
                <path
                  class="fa-primary secondary--text"
                  d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                ></path>
              </g>
            </svg>

            {{ item.area }}
          </div> -->

          <!-- ITEM REVIEWS -->
        </v-col>
      </v-row>
    </template>
    <div
      style="position: fixed; bottom: 4px; left: 0px; right: 0px; padding: 16px"
      class="center"
    >
      <v-row class="ml-6 mr-6" style="width: 100%">
        <v-col cols="6">
          <h2
            :class="[$vuetify.breakpoint.mdAndUp ? 'h1' : 'h1']"
            class="font-weight-bold black--text"
            style="font-size: 2rem; position: end"
          >
            Total:
          </h2>
        </v-col>
        <v-col cols="6" style="text-align: end">
          <h2
            :class="[$vuetify.breakpoint.mdAndUp ? 'h1' : 'h1']"
            class="font-weight-bold black--text"
            style="font-size: 2rem; position: end"
          >
            R{{ totalPrice }}
          </h2></v-col
        >
      </v-row>
      <v-btn
        :disabled="deliveryMethod === ''"
        to="/salesItemPurchase"
        block
        color="accent"
        >Pay Now</v-btn
      >
    </div>
  </v-container>
</template>

<style>
.selected-image {
  border-color: blue; /* Apply a different color outline to the selected image */
}

/* Hide scrollba
/* Hide scrollbar for Chrome, Safari and Opera */
.scroll::-webkit-scrollbar {
  display: none;
  overflow-x: hidden;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scroll {
  -ms-overflow-style: none;
  /* IE and Edge */
  overflow-x: hidden;
  /* Hide horizontal scrollbar */
  scrollbar-width: none;
  /* Firefox */
}

.input {
  border-radius: 12px;
}

.tooltip {
  background: rgb(255, 255, 255) !important;
  width: 400px !important;
  max-width: 100% !important;
  max-height: 100% !important;
  position: absolute;
  z-index: 9;
}

.card {
  border-color: #a2a6ac;
  border-radius: 8px;
}

.text {
  color: #fff;
  /* margin: 5px; */
  text-align: "left";
}

.card:hover {
  border-radius: 8px;
  border-color: rgb(34, 34, 34);
}

.Sbutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  width: 10rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.Sbutton:hover {
  width: 11rem;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

/* .boxx {

} */

.boxx-shadow:after {
  content: "";
  position: absolute;
  width: 100%;
  bottom: 1px;
  z-index: -1;
  transform: scale(0.9);
  box-shadow: 0px 0px 8px 2px #000000;
}

.Ebutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  width: 60%;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.Ebutton:hover {
  width: 21rem;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

.image-div {
  display: flex;
  margin: 25px;
}

.image {
  max-width: 250px;
  margin: 15px;
}

.center {
  display: grid;
  place-items: center;
}
</style>
